
import XHeader from 'vux/src/components/x-header/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
name: 'dormroom',
props: [],
components: {
XHeader,
Panel,
Swiper,
Flexbox,
FlexboxItem,
XButton,
Checker,
CheckerItem
},
data () {
return {
value: ''
}
},
computed: {
title () {
return this.$route.meta.title
}
},
created () {},
mounted () {},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/dormroom/dormChoseRoom.vue